module.exports = __webpack_public_path__ + "img/FLDCOMP_ORANGE.af5c1db1.svg";